var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevronLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.4784 6C14.5471 5.99976 14.6152 6.01312 14.6787 6.03929C14.7422 6.06547 14.7998 6.10395 14.8481 6.15248C14.9454 6.2503 15 6.38228 15 6.51981C15 6.65733 14.9454 6.78932 14.8481 6.88714L10.2997 11.406C10.1388 11.5659 10.0485 11.7828 10.0485 12.0089C10.0485 12.2351 10.1388 12.4519 10.2997 12.6119L14.8474 17.13C14.9381 17.2288 14.9869 17.3585 14.9838 17.4921C14.9807 17.6257 14.926 17.753 14.8309 17.8476C14.7358 17.9421 14.6077 17.9967 14.4732 17.9999C14.3387 18.003 14.2082 17.9546 14.1087 17.8647L9.55814 13.3466C9.38109 13.1711 9.24065 12.9626 9.14488 12.733C9.04911 12.5035 8.99989 12.2574 9.00004 12.0089C8.9983 11.7602 9.04679 11.5137 9.14265 11.2839C9.23851 11.0542 9.3798 10.8459 9.55813 10.6713L14.1066 6.15248C14.2066 6.05669 14.3395 6.0022 14.4784 6Z",
    fill: "#003636"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronLeft);
export default __webpack_public_path__ + "static/media/chevron-left.6b0cc7c75b8ac4e2d488f208ced9ff66.svg";
export { ForwardRef as ReactComponent };